export default {
  STATUS: {
    UPLOADED: { LABEL: 'Enviado', VALUE: 0 },
    CORRECT: { LABEL: 'Usuário Identificado', VALUE: 1 },
    SUSPICIOUS: { LABEL: ' Usuário Não Identificado', VALUE: 2 },
  },
  APPROVAL: {
    NOT_SET: { LABEL: 'Não avaliado', VALUE: 0 },
    APPROVED: { LABEL: 'Aprovado', VALUE: 1 },
    REPROVED: { LABEL: 'Reprovado', VALUE: 2 },
    OBSTRUTION: { LABEL: 'Obstrução', VALUE: 3 },
  },
  VALIDATION_STATUS_FILTER: {
    INACTIVE: { LABEL: 'Inativo', VALUE: 0 },
    ACTIVE: { LABEL: 'Ativo', VALUE: 1 },
    BLOCKED: { LABEL: 'Bloqueado', VALUE: 2 },
    EXPIRED: { LABEL: 'Expirado', VALUE: 3 },
  },
};
